import { FDLozenge, FDStack, FDTooltip } from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import React from 'react';
import { metaOverrides } from './metaOverrides';

export const ScenarioSelectionRedefinedHeaderDesktop = ({ resource, children }) => {
  return (
    <FDStack direction={'row'} spacing={2} justifyContent={'space-between'} wrap>
      <FDStack direction={'row'} spacing={2} alignItems={'center'}>
        <MetaControl attrName={'scenarioName'} resource={resource} metaOverrideSet={metaOverrides} {...dataAttrs('current-proposal-scenario-name')} />
        <FDStack alignItems={'center'}>
          <FDTooltip placement={'bottom'} title={'Roadmaps expire to ensure your actions remain fresh.'}>
            <FDLozenge color={resource.attr('status')} size={'lg'} label={resource.attr('statusLabel')} {...dataAttrs('current-proposal-scenario-status-lozenge')} />
          </FDTooltip>
        </FDStack>
      </FDStack>
      <FDStack direction={'row'} spacing={2} justifyContent={'center'} alignItems={'center'}>
        {children}
      </FDStack>
    </FDStack>
  );
};
